import React from 'react';

// ─── Screen-level loading state ───────────────────────────
//
// The burgundy spinner AppLayout has always shown while the session
// resolves, lifted out so every gate that has to wait shows the same
// thing. <RequireFeature> used to hold an empty <div> instead, which is
// why a hard refresh of a feature-gated route showed several seconds of
// blank white page before the screen appeared: the tenant config had to
// arrive before the gate would release, and nothing was drawn meanwhile.
//
// A gate that is waiting is not a gate that has decided. Draw the wait.
const ScreenLoader = ({ label }) => (
  <div
    role='status'
    aria-busy='true'
    aria-live='polite'
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 14,
      height: '100vh',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f8fafc',
    }}
  >
    <div
      style={{
        width: 32,
        height: 32,
        border: '3px solid #e2e8f0',
        borderTopColor: '#800020',
        borderRadius: '50%',
        animation: 'regure-screen-loader-spin 0.7s linear infinite',
      }}
    />
    {label ? <div style={{ fontSize: 13, color: '#64748b' }}>{label}</div> : null}
    <style>{'@keyframes regure-screen-loader-spin { to { transform: rotate(360deg); } }'}</style>
  </div>
);

export default ScreenLoader;
